const JE = {
  iban: {
    bankStatementRequirement: "REQUIRED",
    defaultCurrency: "GBP",
    fields: [
      "accountHolder",
      "country",
      "iban"
    ]
  },
  local: {
    bankStatementRequirement: "REQUIRED",
    defaultCurrency: "GBP",
    fields: [
      "accountHolder",
      "bankAccountNumber",
      "branchCode",
      "country"
    ]
  }
};
export {
  JE as default
};
